import * as React from 'react';
import {
	Menu as _Menu,
	MenuItem as _MenuItem,
	Popover as _Popover,
	MenuItemProps,
	MenuProps,
	MenuTrigger,
	PopoverProps,
} from 'react-aria-components';

import styles from './menu.module.scss';

const Menu = React.forwardRef<HTMLDivElement, MenuProps<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<_Menu ref={ref} className={`${styles.menu} ${className || ''}`} {...props} />
	),
);
Menu.displayName = 'Menu';

const MenuItem = React.forwardRef<HTMLDivElement, MenuItemProps<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<_MenuItem ref={ref} className={`${styles.menuItem} ${className || ''}`} {...props} />
	),
);
MenuItem.displayName = 'MenuItem';

const Popover = React.forwardRef<HTMLElement, PopoverProps>(({ className, ...props }, ref) => (
	<_Popover ref={ref} className={`${styles.popover} ${className || ''}`} {...props} />
));
Popover.displayName = 'Popover';

export { Menu, MenuItem, MenuTrigger, Popover };
